import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import AdminRequests from "./AdminRequests";
import AreaManagerRequests from "./AreaManagerRequests";

const Requests = () => {
  const { user } = useAuth();
  const isL1 = user?.userLabel !== "Store";
  if (isL1) {
    return <AreaManagerRequests />;
  }
  return <AdminRequests />;
};

export default Requests;
